import React from 'react';

const EnterpriseIcon = ({ className }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.42871 3.42853H4.57157V5.71424H3.42871V3.42853Z" fill="white" />
    <path d="M3.42871 6.85718H4.57157V9.14289H3.42871V6.85718Z" fill="white" />
    <path d="M6.85645 3.42853H7.9993V5.71424H6.85645V3.42853Z" fill="white" />
    <path d="M6.85645 6.85718H7.9993V9.14289H6.85645V6.85718Z" fill="white" />
    <path d="M3.42871 10.2857H4.57157V12.5714H3.42871V10.2857Z" fill="white" />
    <path d="M6.85645 10.2857H7.9993V12.5714H6.85645V10.2857Z" fill="white" />
    <path d="M16 6.85714C16 6.55404 15.8796 6.26335 15.6653 6.04902C15.4509 5.83469 15.1602 5.71429 14.8571 5.71429H11.4286V1.14286C11.4286 0.839753 11.3082 0.549062 11.0938 0.334735C10.8795 0.120408 10.5888 0 10.2857 0H1.14286C0.839753 0 0.549062 0.120408 0.334735 0.334735C0.120408 0.549062 0 0.839753 0 1.14286V16H16V6.85714ZM1.14286 1.14286H10.2857V14.8571H1.14286V1.14286ZM11.4286 14.8571V6.85714H14.8571V14.8571H11.4286Z" fill="white" />
  </svg>
);

export default EnterpriseIcon;
